
import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import SwitchWithConfirm from '@/components/SwitchWithConfirm.vue';
import AttachmentWithStatus from '@/components/AttachmentWithStatus.vue';
import UpdateButton from '@/components/UpdateButton.vue';
import TextFieldWithConfirm from '@/components/TextFieldWithConfirm.vue';
import DateFieldWithConfirm from '@/components/DateFieldWithConfirm.vue';
import SlotWithConfirm from '@/components/SlotWithConfirm.vue';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import Editor from '@/components/Editor.vue';
import {
  getLeadCustomValueBoolean,
  getLeadCustomValueDate,
  getLeadCustomValueText,
} from '@/helpers';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import EditConnectionDialogMixin from '@/mixins/EditConnectionDialogMixin.vue';
import { getProvinceName } from '@/lib/italy';

moment.locale('it');

@Component({
  components: {
    SwitchWithConfirm,
    AttachmentWithStatus,
    UpdateButton,
    TextFieldWithConfirm,
    DateFieldWithConfirm,
    SlotWithConfirm,
    DatePickerDialog,
    Editor,
  },
})
export default class EditENEADialog extends Mixins(EditConnectionDialogMixin, UtilsMixin) {
  practiceNotes: string | null = null
  eneaElettricoNotes: string | null = null

  // Dati del beneficiario
  billingCompany: string | null | undefined = null
  billingVAT: string | null | undefined = null
  billingCompanyTaxCode: string | null | undefined = null
  billingFirstName: string | null | undefined = null
  billingLastName: string | null | undefined = null
  billingTaxCode: string | null | undefined = null
  billingPhone1: string | null | undefined = null
  billingPhone2: string | null | undefined = null
  billingPEC: string | null | undefined = null
  billingEmail: string | null | undefined = null
  billingToponym: string | null | undefined = null
  billingStreet: string | null | undefined = null
  billingHouseNumber: string | null | undefined = null
  billingPostalCode: string | null | undefined = null
  billingLocation: string | null | undefined = null
  billingProvince: string | null | undefined = null

  ragioneSociale: string | null | undefined = null
  partitaIva: string | null | undefined = null
  codiceFiscaleAzienda: string | null | undefined = null
  nome: string | null | undefined = null
  cognome: string | null | undefined = null
  codiceFiscale: string | null | undefined = null
  telefono: string | null | undefined = null
  altroTelefono: string | null | undefined = null
  pec: string | null | undefined = null
  email: string | null | undefined = null
  toponimo: string | null | undefined = null
  indirizzo: string | null | undefined = null
  civico: string | null | undefined = null
  cap: string | null | undefined = null
  citta: string | null | undefined = null
  provincia: string | null | undefined = null

  ubicazioneImmobile: string | null | undefined = null
  datiCatastaliImmobile: string | null | undefined = null
  superficieUtileImmobile: string | null | undefined = null
  unitaImmobiliariEdificio: string | null | undefined = null
  unitaImmobiliariEdificioConfirmed = false
  annoCostruzioneImmobile: string | null | undefined = null
  annoCostruzioneImmobileConfirmed = false
  tipologiaEdiliziaImmobileCv: string | null | undefined = null
  tipologiaEdiliziaImmobile: Array<number> | null | undefined = null
  dataInizioLavori: Date | null = null
  dataFineLavori: Date | null = null
  dataInizioLavoriConfirmed = false
  dataFineLavoriConfirmed = false
  fvEnea: string | null | undefined = null
  batteriaEnea: string | null | undefined = null

  // Aggiorna i campi con gli eventuali nuovi valori della Connection/Lead selezionata
  refresh() {
    console.log(`${this.constructor.name}: refresh()`); // eslint-disable-line no-console

    // Note
    this.practiceNotes = getLeadCustomValueText(this.lead, 'practiceNotes') ?? null;
    if (this.currentElettricaFiglia) {
      this.eneaElettricoNotes = getLeadCustomValueText(this.currentElettricaFiglia, 'eneaElettricoNotes') ?? null;
    }

    // Dati del beneficiario
    this.billingCompany = this.lead?.billingCompany ?? null;
    this.billingVAT = getLeadCustomValueText(this.lead, 'billingVAT') ?? null;
    this.billingCompanyTaxCode = getLeadCustomValueText(this.lead, 'billingCompanyTaxCode') ?? null;
    this.billingFirstName = this.lead?.billingFirstName ?? null;
    this.billingLastName = this.lead?.billingLastName ?? null;
    this.billingTaxCode = getLeadCustomValueText(this.lead, 'billingTaxCode') ?? null;
    this.billingPhone1 = getLeadCustomValueText(this.lead, 'billingPhone1') ?? null;
    this.billingPhone2 = getLeadCustomValueText(this.lead, 'billingPhone2') ?? null;
    this.billingPEC = getLeadCustomValueText(this.lead, 'billingPEC') ?? null;
    this.billingEmail = getLeadCustomValueText(this.lead, 'billingEmail') ?? null;
    this.billingToponym = getLeadCustomValueText(this.lead, 'billingToponym') ?? null;
    this.billingStreet = getLeadCustomValueText(this.lead, 'billingStreet') ?? null;
    this.billingHouseNumber = getLeadCustomValueText(this.lead, 'billingHouseNumber') ?? null;
    this.billingPostalCode = getLeadCustomValueText(this.lead, 'billingPostalCode') ?? null;
    this.billingLocation = getLeadCustomValueText(this.lead, 'billingLocation') ?? null;
    this.billingProvince = getLeadCustomValueText(this.lead, 'billingProvince') ?? null;

    this.ragioneSociale = this.lead?.ragioneSociale ?? null;
    this.partitaIva = this.lead?.partitaIva ?? null;
    this.codiceFiscaleAzienda = this.lead?.codiceFiscaleAzienda ?? null;
    this.nome = this.lead?.nome ?? null;
    this.cognome = this.lead?.cognome ?? null;
    this.codiceFiscale = this.lead?.codiceFiscale ?? null;
    this.telefono = this.lead?.telefono ?? null;
    this.altroTelefono = this.lead?.altroTelefono ?? null;
    this.pec = this.lead?.pec ?? null;
    this.email = this.lead?.email ?? null;
    this.toponimo = this.lead?.toponimo ?? null;
    this.indirizzo = this.lead?.indirizzo ?? null;
    this.civico = this.lead?.civico ?? null;
    this.cap = this.lead?.cap ?? null;
    this.citta = this.lead?.citta ?? null;
    this.provincia = this.lead?.provincia ?? null;

    // FASE 2
    this.ubicazioneImmobile = getLeadCustomValueText(this.lead, 'ubicazioneImmobile') ?? null;
    this.datiCatastaliImmobile = getLeadCustomValueText(this.lead, 'datiCatastaliImmobile') ?? null;
    this.superficieUtileImmobile = getLeadCustomValueText(this.lead, 'superficieUtileImmobile') ?? null;

    this.unitaImmobiliariEdificio = getLeadCustomValueText(this.lead, 'unitaImmobiliariEdificio')
      ?? 'Numero delle unità immobiliari presenti nell’edificio autonomamente individuate al Catasto';
    this.annoCostruzioneImmobile = getLeadCustomValueText(this.lead, 'annoCostruzioneImmobile')
      ?? 'Se l’anno di costruzione non è noto con certezza, è sufficiente stimarlo';

    // gestione customValue tipologia edilizia con selezione multipla
    this.tipologiaEdiliziaImmobileCv = getLeadCustomValueText(this.lead, 'tipologiaEdiliziaImmobile') ?? '';
    this.tipologiaEdiliziaImmobile = this.tipologiaEdiliziaImmobileCv.substring(1, this.tipologiaEdiliziaImmobileCv.length - 1).split(':')
      .map((s: string) => Number(s));

    this.dataInizioLavori = getLeadCustomValueDate(this.lead, 'dataInizioLavori') ?? null;
    this.dataFineLavori = getLeadCustomValueDate(this.lead, 'dataFineLavori') ?? null;

    this.unitaImmobiliariEdificioConfirmed = getLeadCustomValueBoolean(this.lead, 'unitaImmobiliariEdificioConfirmed') ?? false;
    this.annoCostruzioneImmobileConfirmed = getLeadCustomValueBoolean(this.lead, 'annoCostruzioneImmobileConfirmed') ?? false;
    this.dataInizioLavoriConfirmed = getLeadCustomValueBoolean(this.lead, 'dataInizioLavoriConfirmed') ?? false;
    this.dataFineLavoriConfirmed = getLeadCustomValueBoolean(this.lead, 'dataFineLavoriConfirmed') ?? false;

    // FASE 3
    this.fvEnea = (getLeadCustomValueText(this.lead, 'fvEnea')
      ?? 'Vedere la colonna \'Fornitura\', il progetto, le foto installazione e la pratica di connessione');
    this.batteriaEnea = getLeadCustomValueText(this.lead, 'batteriaEnea')
      ?? 'Vedere la colonna \'Fornitura\', il progetto, le foto installazione e la pratica di connessione';

    // Richiama il metodo del mixin
    return this.mixinRefresh();
  }

  @Watch('currentElettricaFiglia')
  onElettricaFigliaChange() {
    if (this.currentElettricaFiglia) {
      this.eneaElettricoNotes = getLeadCustomValueText(this.currentElettricaFiglia, 'eneaElettricoNotes') ?? null;
    }
  }

  onFieldUpdated(field: string, value: unknown = undefined) {
    console.log(`${this.constructor.name}: onFieldUpdated(${field})`); // eslint-disable-line no-console

    // Richiama il metodo del mixin
    return this.mixinOnFieldUpdated(field, value);
  }

  isBusiness(type = ''): boolean {
    switch (type) {
      case 'billing':
        return this.lead?.billingType === 'business';

      case 'installation':
        return this.lead?.installationType === 'business';

      default:
        break;
    }

    return this.lead?.tipoCliente === 'business';
  }

  isPerson(type = ''): boolean {
    switch (type) {
      case 'billing':
        return this.lead?.billingType === 'person';

      case 'installation':
        return this.lead?.installationType === 'person';

      default:
        break;
    }

    return this.lead?.tipoCliente === 'person';
  }

  provinceName(province: string | null | undefined): string {
    return province ? getProvinceName(province) : '';
  }
}
